import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-background paper-grain grid place-items-center px-6">
      <div className="max-w-md w-full rounded-3xl border border-border bg-card p-10 text-center" data-testid="payment-cancel-card">
        <XCircle className="mx-auto mb-4 text-muted-foreground" size={44} />
        <h1 className="text-3xl mb-2">Checkout cancelled.</h1>
        <p className="text-muted-foreground mb-8">You weren't charged. Come back whenever you're ready.</p>
        <div className="flex gap-3 justify-center">
          <Button onClick={() => navigate("/")} className="rounded-full h-12 px-6">Back to home</Button>
          <Button variant="secondary" onClick={() => navigate("/#pricing")} className="rounded-full h-12 px-6">See plans</Button>
        </div>
      </div>
    </div>
  );
}
